import {LinkProps, NavLink as _NavLink} from 'react-router-dom';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {FC, ReactNode} from 'react';
import {Group} from '@mantine/core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {css} from '@emotion/react';
import {PrimaryColorCssVar} from '../styles/default-theme.tsx';
import {
  ProtectedElement,
  useRequireAuthorizationProps,
} from '../auth/require-authorization.tsx';

type NavLinkProps = {to: LinkProps['to']} & (
  | {
      icon: IconProp;
      title: string;
      children?: never;
    }
  | {
      icon?: never;
      title?: never;
      children: ReactNode;
    }
);

export type PrimaryNavLinkProps = NavLinkProps & {
  authProps?: useRequireAuthorizationProps;
};

export const PrimaryNavLink: FC<PrimaryNavLinkProps> = (props) => {
  const {authProps, ...navProps} = props;

  if (authProps) {
    return (
      <ProtectedElement {...authProps}>
        <NavLink {...navProps} />
      </ProtectedElement>
    );
  }

  return <NavLink {...navProps} />;
};

const NavLink: FC<NavLinkProps> = ({to, icon, title, children}) => {
  return (
    <_NavLink to={to} css={navLinkCss}>
      {children ?? (
        <Group gap={'xs'}>
          <FontAwesomeIcon icon={icon as IconProp} /> {title}
        </Group>
      )}
    </_NavLink>
  );
};

export const navLinkCss = css({
  color: 'black',
  fontSize: '14px',
  transition: 'color 0.5s ease',
  cursor: 'pointer',
  textDecoration: 'none',
  fontWeight: 'bolder',

  '&.active, &:hover': {color: PrimaryColorCssVar},
});
